import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const agentList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/agent?` + params,
        method: 'GET'
    })
}

export const editAgent = (params) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/agent`,
        method: 'PUT',
        data: params
    })
}
export const findDepartmentDetail = (id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/department/${id}`,
        method: 'GET'
    })
}
// 获取findMenusMaterialDetail材料分类
export const getMaterialDataById = (id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/material_category/materialGroup/${id}`,
        method: 'GET'
    })
}
export const putMaterialDataById = (params) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/material_category/materialGroup`,
        method: 'PUT',
        data: params
    })
}
export const address = (params) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/department/address`,
        method: 'PUT',
        data: params
    })
}
export const agentAddress = (companyId) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/department/agent_address/${companyId}`,
        method: 'GET'
    })
}